"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyle = void 0;
const react_1 = require("react");
const useStyle = (styleFactory, deps) => react_1.useMemo(styleFactory, deps);
exports.useStyle = useStyle;
